var map = {
	"./computer.png": 9889,
	"./design.png": 6716,
	"./entrepreneaur.png": 9572,
	"./innovation.png": 1983
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7598;
module.exports = webpackAsyncContext;